document.addEventListener("DOMContentLoaded", function(event) {
    if(document.querySelector('.table-wrapper')) {
        clonePronamelTableMobile();
    }
});

function clonePronamelTableMobile() {
    if (window.innerWidth < 751) {
        const tableWrapper = document.querySelector('.table-wrapper');
        const newTableWrapper = tableWrapper.cloneNode(true);
        tableWrapper.insertAdjacentElement('afterend', newTableWrapper);
    }
}